// import components
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';
import {
  ControlledAutoComplete,
  ControlledTextField
} from 'components/shared/ControlledFields';

// import hooks
import { useState } from 'react';

const ControlledFormFieldsArray = ({ field, disabled, control }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  const handleMouseUpPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  if (field.type === 'autocomplete') {
    return (
      <ControlledAutoComplete
        key={field.name}
        control={control}
        name={field.name}
        label={field.labelKey ?? ''}
        options={field.options ?? []}
        disabled={disabled}
        variant="outlined"
        fullWidth
      />
    );
  }

  if (field.type === 'password') {
    return (
      <ControlledTextField
        key={field.name}
        control={control}
        name={field.name}
        label={field.labelKey}
        type={showPassword ? 'text' : 'password'}
        disabled={disabled}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={
                    showPassword ? 'hide the password' : 'display the password'
                  }
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )
          }
        }}
        fullWidth
      />
    );
  }

  return (
    <ControlledTextField
      key={field.name}
      control={control}
      name={field.name}
      label={field.labelKey ? field.labelKey : undefined}
      disabled={disabled}
      fullWidth
      sx={field.type === 'hidden' ? { display: 'none' } : undefined}
    />
  );
};

export default ControlledFormFieldsArray;
